module.exports = __webpack_public_path__ + "img/qywxactive.0c41e616.png";